<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Demandes</span>
        <h3 class="page-title">{{ $t("days.off.requestManagement.title") }}</h3>
      </div>
    </div>
    <!-- Table -->
    <div class="row">
      <div class="col">
        <div
          class="card card-small mb-4 mt-3"
          v-if="loading || !user.connected"
        >
          <div class="card-body">
            <spinner-dot />
          </div>
        </div>
        <div v-else>
          <div class="card card-small mb-4 mt-3">
            <div class="header-data-table">
              <h5 class="header-data-table__heading">Demande de conges</h5>
            </div>
            <LeaveRequestFilter :statusList="statusList" />
            <change-date-dialog
              :dialog="dialog"
              :toggleDialog="toggleDialog"
              :request="requestToEdit"
            />
            <div class="card-body">
              <data-table
                :data="dayOffGridData"
                :fields="gridColumnsTitle"
                :selectedFields="daysOffFields"
                :fieldsGrid="gridColumnsFields"
                :tableState="state"
                :count="count"
              ></data-table>
            </div>
          </div>
        </div>
        <simple-modal ref="reasonModal" :motif="selectedMotif" />
      </div>
    </div>
  </div>
</template>

<script>
import daysOffType from "../../data/daysOff/daysOffType";
import TimeUtils from "../../utils/TimeUtils";
import moment from "moment-timezone";
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import DataTable from "../../components/dataTable/dataTable";
import SimpleModal from "../../components/abscenceRequest/SimpleModal";
import absceneRequestGrid from "../../data/dataTable/absceneRequestGrid.json";
import LeaveRequestFilter from "./LeaveRequestFilter";
import ChangeDateDialog from "./ChangeDateDialog";
export default {
  components: {
    SimpleModal,
    DataTable,
    SpinnerDot,
    LeaveRequestFilter,
    ChangeDateDialog
  },
  props: ["reference"],
  data() {
    return {
      dialog: false,
      daysOffHistory: [],
      requestToEdit: {},
      count: 0,
      model: {},
      selectedMotif: "",
      // all values available for the table
      gridColumnsFields: absceneRequestGrid.grid,
      gridColumnsTitle: absceneRequestGrid.grid.map(grid => grid.title),
      loading: true,
      daysOffFields: [
        "Nom et prénom",
        "Date demande",
        "Date debut",
        "Date fin",
        "Nombre de jours",
        "Type",
        "Status",
        "Motif",
        "Action"
      ],

      daysOffFieldsGridFill: {
        "Action nécéssaire": request => {
          
          //Prendre tous les answers de cette demande
          let answers = request.answers;
          //Variable du status
          let status;
          //Variable true si l'action est nécéssaire et false sinon
          let action;
          //La reference du user courant
          let userReference = this.$store.state.user.informations.reference;
          //Parcourir les answers
          for (let i in answers) {
            //Instancier chaque answer
            let answer = answers[i];
            //Chercher la answer correspondante à notre user
            if (answer.userReference == userReference) {
              
              //Prendre e status
              status = answer.status;
              
            }
          }
          if (status===undefined){
            return true
          }
          //Si le status du user est pending et le status de la demande est null (il est ni ACCEPTED ni REJECTED)
          if (status.toLowerCase() == "pending" && request.status == null) {
            action = true;
          } else {
            action = false;
          }
          return action;
        },
        "Nom et prénom": request => ({
          firstName: request.firstName,
          lastName: request.lastName
        }),
        "Date demande": request => TimeUtils.formatDate(request.creationDate),
        "Date debut": request => TimeUtils.formatDate(request.dates[0].from),
        "Date fin": request => TimeUtils.formatDate(request.dates[0].to),
        "Nombre de jours": request =>
          request.type === "DAYS_OFF"
            ? request.answers.filter(
                item =>
                  item.groupReference === "_compta" && item.status !== "PENDING"
              ).length > 0
              ? request.model.totalDaysOff
              : ""
            : "",
        Type: request =>
          request.model.type
            ? daysOffType[request.model.type].name
            : daysOffType[request.type].name,
        Status: request => request.status || "En attente...",
        Motif: request => {
          if (request.declineReason) {
            return {
              component: "button-td",
              class: "btn-danger",
              icon: "fa fa-eye",
              action: this.showReason,
              id: request.declineReason
            };
          }
          return "N/A";
        },
        Action: request => {
          return [
            {
              component: "button-td",
              class: "btn-accent",
              content: "Voir la demande",
              action: () => this.goToLeaveRequest(request),
              id: request.declineReason
            },
            this.check_compta()
              ? request.status === "ACCEPTED" || request.status === undefined
                ? {
                    component: "button-td",
                    class: "btn-white",
                    content: "Edit",
                    action: () => this.edit_demand(request),
                    id: request.declineReason
                  }
                : {}
              : {},
            this.check_compta() &&
            request.status !== "CANCELED" &&
            request.status !== "REFUSED"
              ? {
                  component: "button-td",
                  class: "btn-danger",
                  content: "Annuler",
                  action_yes: numberOfDays =>
                    this.cancel_demand_with_restaure(request, numberOfDays),
                  action_no: () => this.cancel_demand(request),
                  id: request.declineReason,
                  numberOfDays:
                    request.answers.filter(
                      item =>
                        item.groupReference === "_compta" &&
                        item.status !== "PENDING"
                    ).length > 0
                      ? request.model.totalDaysOff
                        ? request.model.totalDaysOff
                        : 0
                      : 0
                }
              : {}
          ];
        }
      },
      state: {
        page: 1,
        perPage: 10,
        field: "Date de cr�ation",
        ascending: false
      },
      statusList: ["PENDING", "ACCEPTED", "REFUSED", "CANCELED"],
      filterQuery: {},
      filteredDaysOff: [],
      dayOffGridData: []
    };
  },

  watch: {
    state: {
      handler() {
        this.daysOffFetch();
      },
      deep: true
    },
    filterQuery() {
      // searchDaysOffFetch
      if (Object.keys(this.filterQuery).length === 0) {
        this.daysOffFetch();
      } else {
        this.searchDaysOffFetch();
      }
    },
    daysOffHistory() {
      
      if (this.filterQuery.dates) {
        const { from, to } = this.filterQuery.dates;
        const filtered = this.daysOffHistory.filter(item => {
          const { dates } = item;
          if (from && to) {
            return dates[0].from >= from && dates[0].to <= to;
          } else if (!from) {
            return dates[0].to <= to;
          } else if (!to) {
            
            return dates[0].from >= from;
          }
          return true;
        });
        this.filteredDaysOff = this.filterQuery.status
          ? this.filterQuery.status === "PENDING"
            ? filtered.filter(item => item.status === undefined)
            : filtered.filter(item => item.status === this.filterQuery.status)
          : filtered;
      } else {
        this.filteredDaysOff = this.filterQuery.status
          ? this.filterQuery.status === "PENDING"
            ? this.daysOffHistory.filter(item => item.status === undefined)
            : this.daysOffHistory.filter(
                item => item.status === this.filterQuery.status
              )
          : this.daysOffHistory;
      }
    },
    filteredDaysOff() {
      this.dayOffGridData = this.filteredDaysOff.map(user => {
        const res = {};
        this.daysOffFields.forEach(field => {
          if (this.daysOffFieldsGridFill[field]) {
            res[field] = this.daysOffFieldsGridFill[field](user);
          }
          res["Action nécéssaire"] = this.daysOffFieldsGridFill[
            "Action nécéssaire"
          ](user);
        });
        return res;
      });
    }
  },

  computed: {
    user() {
      return this.$store.state.user.informations;
    }
  },

  methods: {
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    cancel_demand_with_restaure(request, numberOfDays) {
      const model = {
        status: "CANCELED",
        userReference: this.user.reference,
        motif: "Annulée par le comptable"
      };
      this.$services.absenceRequest
        .confirmRequest(request.reference, model)
        .then(({ data }) => {
          this.request = data;
          this.alreadyAnswered(request);
          this.$miniToastr.success("Cette demande a été annulée");
          this.daysOffFetch();
        })
        .catch(() => (this.loading = false));
      this.$services.user
        .updateLeftVacations({
          selectedUsers: [request.userReference],
          days: Number(numberOfDays),
          mode: "INCREMENT"
        })
        .then(() => {
          this.$miniToastr.success(this.$t("user.edit.success"));
          this.selectedUsers = [];
          this.appliedToAll = false;
          this.fetchUsers();
        })
        .catch(() => (this.loading = false));
    },
    edit_demand(request) {
      this.requestToEdit = request;
      this.dialog = true;
    },
    alreadyAnswered(request) {
      const a = request.answers.find(
        answer => answer.userReference === this.user.reference
      );
      if (a.status !== "PENDING") {
        this.answered = true;
      }
    },
    cancel_demand(request) {
      const model = {
        status: "CANCELED",
        userReference: this.user.reference,
        motif: "Annulée par le comptable"
      };

      this.$services.absenceRequest
        .confirmRequest(request.reference, model)
        .then(({ data }) => {
          this.request = data;
          this.alreadyAnswered(request);
          this.$miniToastr.success("Cette demande a été annulée");
          this.daysOffFetch();
        })
        .catch(() => (this.loading = false));
    },
    check_compta() {
      const { permissions } = this.$store.state.user.informations;
      const permission = permissions.find(
        item => item.groupReference === "_compta"
      );

      return permission != undefined;
    },
    showReason(reason) {
      this.selectedMotif = reason;
      this.$refs.reasonModal.openModal();
    },
    goToLeaveRequest(request) {
      this.$router.push(`/demandes/repondre/${request.reference}`);
    },
    async daysOffFetch() {
      this.loading = true;
      const types = ["CP", "CS", "OTHER"];
      await this.$services.absenceRequest
        .findAllUnderCharge(
          this.user.reference,
          null,
          null,
          null,
          this.state.page,
          this.state.perPage,
          this.state.field,
          this.state.ascending,
          this.gridColumnsFields
        )
        .then(res => {

          this.loading = false;
          this.count = res.data.count;
          this.daysOffHistory = res.data.data;
        });
    },
    async searchDaysOffFetch() {
      this.loading = true;
      const types = ["CP", "CS", "OTHER"];
      await this.$services.absenceRequest
        .findAllUnderCharge(this.user.reference,          {
            status:
              this.filterQuery.status === "PENDING"
                ? undefined
                : this.filterQuery.status,
            model: types.includes(this.filterQuery.type)
              ? {
                  type: this.filterQuery.type
                }
              : {},
            type: !types.includes(this.filterQuery.type)
              ? this.filterQuery.type
              : undefined,
            firstName: this.filterQuery.firstName
              ? this.filterQuery.firstName
              : undefined,
            lastName: this.filterQuery.lastName
              ? this.filterQuery.lastName
              : undefined
          })
        .then(res => {
          this.loading = false;
          this.count = res.data.count;
          this.daysOffHistory = res.data;
        });
    }
  },

  mounted() {
    if (!this.reference) {
      this.model = { userReference: this.user.reference };
    } else {
      this.model = { userReference: this.reference };
    }
    this.filterQuery = this.$store.state.absenceRequest.filter;
    this.daysOffFetch();
    this.$root.$on("refresh", () => {
      this.daysOffFetch();
    });
    this.$root.$on("searchRequests", query => {
      this.filterQuery = query;
    });
  }
};
</script>

<style></style>
